import React from "react";
import ChartGoal from "charts/ChartGoal";
import ChartLine from "charts/ChartLine";
import ChartPie from "charts/ChartPie";
import ChartBar from "charts/ChartBar";
import ChartLocation from "charts/ChartLocation";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import KPIMetricBlock from "dashboards/KPIMetricBlock";
import MetricFormatter from "dashboards/MetricFormatter";
import MetricTablePdf from "MetricTablePdf";
import ServiceDisabled from "dashboards/ServiceDisabled";
import GetFormatter from "dashboards/GetFormatter";
import NoData from "dashboards/NoData";
import jsDig from "utils/jsDig";
import allMetrics from "data/allMetrics.js";
import PDFPage from "pdfs/PDFPage";
import { camelCase, cloneDeep } from "lodash-es";
import getNegative from "../utils/getNegative";
import getGoalLocked from "utils/getGoalLocked";
import dashboardTableOrder from "../utils/dashboardTableOrder";

const allMetricData = allMetrics();
const ageKeyOrder = ["18-24", "25-34", "35-44", "45-54", "55-64", "65+", "unknown"];
const dayKeyOrder = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
const hourKeyOrder = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
];

class PPCPdfVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.goalChartDim = "135x135";
    this.lineChartDim = "350x250";
    this.pieChartDim = "175x175";
    this.goalsPerRow = 5;
    this.chartsPerRow = 2;
    this.tablesPerRow = 1;
    this.kpiBlocksPerRow = 3;
    this.metricsPerTable = 4;
    this.goalRowHeight = 144;
    this.chartRowHeight = 300;
    this.tableRowHeight = 315;
    this.groupTableRowHeight = 355;
    this.kpiBlockRowHeight = 200;
    this.pieRowHeight = 240;
    this.barRowHeight = 340;
    this.mapRowHeight = 600;
  }

  generatePdfSection(section, cc_data, dashboard) {
    const metricData = allMetricData["metricData"];
    let date = this.props.date ? moment(this.props.date) : moment();
    let month = date.format("MMM");
    let year = date.year();
    let campaignGroupCase;
    function categorize(string) {
      if (string.includes("campaignGroups")) {
        campaignGroupCase = string;
      }
      return string;
    }
    if (section.metrics_data) {
      const renderArray = dashboardTableOrder("ppc", Object.keys(section.metrics_data));
      switch (categorize(section.name)) {
        case "goalsAndProjections":
          let goals = this.props.goals;
          return (
            <>
              <h2 style={{ textAlign: "center" }}>Goals & Projections </h2>
              <Row xs={this.goalsPerRow} className="justify-content-center">
                {renderArray.map((metricName, index) => {
                  const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                  const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                  const current = jsDig([dashboard, metricKey, "raw"], cc_data);
                  const goal = parseFloat(jsDig([dashboard, year, month, camelCase(metricKey)], goals));
                  const projected = jsDig([dashboard, metricKey, "projected"], cc_data);
                  const negative = getNegative(section.name, metricKey, projected - goal, cc_data);
                  const goalLocked = getGoalLocked(date, metricKey);
                  if (metricKey) {
                    if (jsDig([dashboard, metricKey, "raw"], cc_data) != null) {
                      if (section.metrics_data[metricName] == "1") {
                        let Formatter = GetFormatter({ metricName: metricKey });
                        return (
                          <Col key={index}>
                            <ChartGoal
                              metricName={metricShortened}
                              current={current}
                              goal={goal}
                              projected={projected}
                              formatter={Formatter}
                              negative={negative}
                              goalLocked={goalLocked}
                              baseCurrency={this.props.base_currency}
                              displayCurrency={this.props.display_currency}
                              pdfDim={this.goalChartDim}
                            />
                          </Col>
                        );
                      }
                    } else {
                      return (
                        <p className="text-danger" key={index}>
                          {metricKey} was not found in cc_data
                        </p>
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger" key={index}>
                        {metricName} not defined in metricData.json
                      </p>
                    );
                  }
                })}
              </Row>
            </>
          );
        case "primaryKpiCharts":
          return (
            <>
              <h2 style={{ textAlign: "center" }}>Primary KPI's</h2>

              <Row sm={this.chartsPerRow} className="justify-content-center">
                {renderArray.map((metricName, index) => {
                  const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                  const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                  if (metricKey) {
                    if (jsDig([dashboard, "metrics_by_months", metricKey], cc_data) != null) {
                      if (section.metrics_data[metricName] == "1") {
                        let Formatter = GetFormatter({ metricName: metricKey, tick: true });
                        return (
                          <Col key={index}>
                            <ChartLine
                              metricName={metricShortened}
                              currentYear={jsDig([dashboard, "metrics_by_months", metricKey, 0, "year"], cc_data)}
                              currentYearData={jsDig([dashboard, "metrics_by_months", metricKey, 0, "data"], cc_data)}
                              previousYear={jsDig([dashboard, "metrics_by_months", metricKey, 1, "year"], cc_data)}
                              previousYearData={jsDig([dashboard, "metrics_by_months", metricKey, 1, "data"], cc_data)}
                              tickFormatter={Formatter}
                              baseCurrency={this.props.base_currency}
                              displayCurrency={this.props.display_currency}
                              pdfDim={this.lineChartDim}
                            />
                          </Col>
                        );
                      }
                    } else {
                      return (
                        <p className="text-danger" key={index}>
                          {metricKey} was not found in metrics_by_month in cc_data
                        </p>
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger" key={index}>
                        {metricName} not defined in metricData.json
                      </p>
                    );
                  }
                })}
              </Row>
            </>
          );
        case "primaryKpiTables":
          let metricTitles = [];
          return (
            <>
              <Row sm={this.tablesPerRow} className="justify-content-center">
                {renderArray.map((metricName, index) => {
                  const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                  if (metricKey) {
                    metricTitles.push(metricKey);
                    if (jsDig([dashboard, "metrics_2_years", metricKey], cc_data) == null) {
                      return (
                        <p className="text-danger" key={index}>
                          {metricKey} was not found in metrics_2_years in cc_data
                        </p>
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger" key={index}>
                        {metricName} not defined in metricData.json
                      </p>
                    );
                  }
                })}

                {[...Array(Math.ceil(metricTitles.length / 4))].map((x, index) => {
                  return (
                    <Col className="skinny-table" key={index}>
                      <MetricTablePdf
                        table={jsDig([dashboard, "metrics_2_years"], cc_data)}
                        client={this.props.client_name}
                        headerOrder={metricTitles.splice(0, 4)}
                        date={this.props.date}
                        scrollMessage={false}
                        responsive={false}
                        baseCurrency={this.props.base_currency}
                        displayCurrency={this.props.display_currency}
                      />
                    </Col>
                  );
                })}
              </Row>
            </>
          );
        case "allKpisVsPreviousYear":
          return (
            <>
              <h2 style={{ textAlign: "center" }}>KPI's vs Previous Year</h2>

              <div className="metric-blocks">
                {renderArray.map((metricName, index) => {
                  const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                  const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                  if (metricKey) {
                    if (jsDig([dashboard, metricKey], cc_data) != null) {
                      if (section.metrics_data[metricName] == "1") {
                        let Formatter = GetFormatter({ metricName: metricKey });
                        const negative = getNegative(section.name, metricKey, jsDig([dashboard, metricKey, "projected_yy"], cc_data));
                        return (
                          <KPIMetricBlock
                            metricName={metricShortened}
                            metric={<Formatter client={this.props.client_name} value={jsDig([dashboard, metricKey, "projected"], cc_data)} baseCurrency={this.props.base_currency} displayCurrency={this.props.display_currency} />}
                            yy={<MetricFormatter.YY value={jsDig([dashboard, metricKey, "projected_yy"], cc_data)} />}
                            negative={negative}
                            key={index}
                          />
                        );
                      }
                    } else {
                      return (
                        <p className="text-danger d-inline-block" key={index}>
                          {metricKey} was not found in cc_data
                        </p>
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger d-inline-block" key={index}>
                        {metricName} not defined in metricData.json
                      </p>
                    );
                  }
                })}
              </div>
            </>
          );
        case campaignGroupCase:
          const campaignName = campaignGroupCase.replace("campaignGroups", "");
          const campaignGroup = this.props.campaign_groups.find((el) => el.name == campaignName);

          return (
            <>
              {[campaignGroup.id].map((group_id, index) => {
                let metricTitles = [];
                return (
                  <Row sm={this.tablesPerRow} className="justify-content-center" key={index}>
                    <h2 className="text-center">{campaignGroup.name}</h2>
                    {renderArray.map((metricName, index) => {
                      const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                      if (metricKey) {
                        metricTitles.push(metricKey);
                        if (jsDig([group_id, "metrics_2_years", metricKey], cc_data) == null) {
                          return (
                            <p className="text-danger" key={index}>
                              {metricKey} was not found in metrics_2_years in cc_data for campaign group {group_id}
                            </p>
                          );
                        }
                      } else {
                        return (
                          <p className="text-danger" key={index}>
                            {metricName} not defined in metricData.json
                          </p>
                        );
                      }
                    })}

                    {[...Array(Math.ceil(metricTitles.length / 4))].map((x, index) => {
                      return (
                        <Col className="skinny-table" key={index}>
                          <MetricTablePdf
                            table={jsDig([group_id, "metrics_2_years"], cc_data)}
                            client={this.props.client_name}
                            headerOrder={metricTitles.splice(0, 4)}
                            date={this.props.date}
                            scrollMessage={false}
                            responsive={false}
                            baseCurrency={this.props.base_currency}
                            displayCurrency={this.props.display_currency}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                );
              })}
            </>
          );
        case "spendAllocationPies":
          return (
            <>
              <h2 style={{ textAlign: "center" }}>Spend Allocation</h2>
              <Row xs={3} className="justify-content-left">
                <Col>
                  <div className="spend-allocation-module" style={{ backgroundColor: "#EEE" }}>
                    <h4>By Platform</h4>
                    <ChartPie
                      data={jsDig([dashboard, "metrics_by_platform"], cc_data)}
                      metricsEnabled={["spend"]}
                      id="social-spend-by-platform"
                      baseCurrency={this.props.base_currency}
                      displayCurrency={this.props.display_currency}
                      pdfDim={this.pieChartDim}
                    />
                  </div>
                </Col>
                <Col>
                  <div className="spend-allocation-module" style={{ backgroundColor: "#EEE" }}>
                    <h4>By Device</h4>
                    <ChartPie
                      data={jsDig([dashboard, "metrics_by_device"], cc_data)}
                      metricsEnabled={["spend"]}
                      id="social-spend-by-device"
                      baseCurrency={this.props.base_currency}
                      displayCurrency={this.props.display_currency}
                      pdfDim={this.pieChartDim}
                    />
                  </div>
                </Col>
                <Col>
                  <div className="spend-allocation-module" style={{ backgroundColor: "#EEE" }}>
                    <h4>By Gender</h4>
                    <ChartPie
                      data={jsDig([dashboard, "metrics_by_gender"], cc_data)}
                      metricsEnabled={["spend"]}
                      id="social-spend-by-gender"
                      baseCurrency={this.props.base_currency}
                      displayCurrency={this.props.display_currency}
                      pdfDim={this.pieChartDim}
                    />
                  </div>
                </Col>
              </Row>
            </>
          );
        case "spendAllocationBars1":
          return (
            <>
              <Row sm={2}>
                <Col>
                  <div className="spend-allocation-module mt-4" style={{ backgroundColor: "#EEE" }}>
                    <h4>By Age</h4>
                    <ChartBar
                      data={jsDig([dashboard, "metrics_by_age"], cc_data)}
                      order={ageKeyOrder}
                      metricsEnabled={["spend"]}
                      id="social-spend-by-age"
                      baseCurrency={this.props.base_currency}
                      displayCurrency={this.props.display_currency}
                      pdfDim={"350x250"}
                    />
                  </div>
                </Col>
                <Col>
                  <div className="spend-allocation-module mt-4" style={{ backgroundColor: "#EEE" }}>
                    <h4>By Day-of-the-Week</h4>
                    <ChartBar
                      data={jsDig([dashboard, "metrics_by_day"], cc_data)}
                      order={dayKeyOrder}
                      metricsEnabled={["spend"]}
                      id="social-spend-by-day"
                      baseCurrency={this.props.base_currency}
                      displayCurrency={this.props.display_currency}
                      pdfDim={"350x250"}
                    />
                  </div>
                </Col>
              </Row>
            </>
          );
        case "spendAllocationBars2":
          return (
            <>
              <Row xs={1}>
                <Col>
                  <div className="spend-allocation-module mt-4" style={{ backgroundColor: "#EEE" }}>
                    <h4>By Time-of-Day</h4>
                    <ChartBar
                      data={jsDig([dashboard, "metrics_by_hour"], cc_data)}
                      order={hourKeyOrder}
                      metricsEnabled={["spend"]}
                      id="social-spend-by-hour"
                      baseCurrency={this.props.base_currency}
                      displayCurrency={this.props.display_currency}
                      pdfDim={"700x250"}
                    />
                  </div>
                </Col>
              </Row>
            </>
          );
        case "spendAllocationMap":
          return (
            <>
              <Row xs={1}>
                <Col>
                  <div className="spend-allocation-module mt-4" style={{ backgroundColor: "#EEE" }}>
                    <h4>By Location</h4>
                    <ChartLocation
                      data={jsDig([dashboard, "metrics_by_state"], cc_data)}
                      metricsEnabled={["spend"]}
                      id="social-spend-by-state"
                      urlOrigin={this.props.url_origin}
                      baseCurrency={this.props.base_currency}
                      displayCurrency={this.props.display_currency}
                      pdfDim={"700x250"}
                    />
                  </div>
                </Col>
              </Row>
            </>
          );
        default:
          return (
            <>
              <h4 className="text-danger">{section.name} is not a valid section name for this dashboard</h4>
            </>
          );
      }
    }
  }

  generatePdfPage(page, cc_data, dashboard, index) {
    if (page["metricNames"]) {
      let sectionNames = page["metricNames"].map((metric) => metric["section"]).filter((value, index, self) => self.indexOf(value) === index);
      let sections = [];
      // Create sections object and format how the dashboard generation loop expects
      sectionNames.forEach((section) => {
        sections.push({
          name: section,
          metrics_data: page["metricNames"]
            .filter((m) => m["section"] == section)
            .reduce((sum, item) => {
              sum[item["name"]] = "1";
              return sum;
            }, {}),
        });
      });

      console.log("Sections:");
      console.log(sections);

      return (
        <>
          <PDFPage pageNumber={index + 1} hideLogo={this.props.white_label_service}>
            {index == 0 && (
              <div className="pdf-header justify-content-center">
                <h1 className="text-white text-center">{this.props.client_name} Video Dashboard</h1>
                <h5 className="text-white text-center">{this.props.date_formatted}</h5>
              </div>
            )}
            {sections.map((section) => {
              return (
                <div className={`${section.name.includes("campaignGroup") && Object.keys(section.metrics_data).length < 3 && "d-inline-block w-50 px-2"} `}>
                  {this.generatePdfSection(section, cc_data, dashboard)}
                </div>
              );
            })}
          </PDFPage>
        </>
      );
    } else {
      return (
        <>
          <h4 className="text-danger">no metricsData in page</h4>
        </>
      );
    }
  }

  render() {
    const dashboard = parseInt(this.props.dashboard);
    const cc_data = this.props.cc_data;
    const sectionList = jsDig(["metricsByDashboard", "video", "sections"], allMetricData);
    const defaultMetrics = jsDig(["metricsByDashboard", "video", "defaults", this.props.client_type], allMetricData);

    let dashboardOrder =
      jsDig([dashboard], this.props.dashboard_order) && jsDig([dashboard], this.props.dashboard_order).length > 0
        ? cloneDeep(jsDig([dashboard], this.props.dashboard_order))
        : Object.keys(sectionList).map((sectionName) => {
            let defaultMetricsData = defaultMetrics[sectionName] ? Object.keys(defaultMetrics[sectionName]) : [];
            return {
              name: sectionName,
              enabled: true,
              metrics_data: defaultMetricsData.reduce((sum, item) => {
                sum[item] = "1";
                return sum;
              }, {}),
            };
          });
    if (dashboard > 0) {
      const tempIndex = this.props.campaign_groups.findIndex((el) => el.id == dashboard);
      dashboardOrder = this.props.campaign_groups[tempIndex].dashboard_order;
    }
    let campaignIndex = dashboardOrder.findIndex((el) => el.name == "campaignGroups");
    const copyOfCampaignMetric = campaignIndex == -1 && dashboard > 0 ? cloneDeep(dashboardOrder[dashboard]) : cloneDeep(dashboardOrder[campaignIndex]);
    dashboard == 0 && dashboardOrder.splice(campaignIndex, 1);
    this.props.campaign_groups.forEach((group) => {
      let duplicateCampaign = copyOfCampaignMetric;
      duplicateCampaign["name"] = `campaignGroups${group.name}`;
      dashboardOrder.splice(campaignIndex, 0, cloneDeep(duplicateCampaign));
      campaignIndex += 1;
    });

    // Break up spend allocation into 4 sections
    let allocationIndex = dashboardOrder.findIndex((el) => el.name == "spendAllocation");
    const allocationMetrics = cloneDeep(dashboardOrder[allocationIndex]);
    dashboardOrder.splice(allocationIndex, 1);
    [...Array(4)].forEach((x, index) => {
      let allocationSection = allocationMetrics;
      let sectionName;
      if (index == 0) {
        sectionName = "Pies";
      } else if (index == 1) {
        sectionName = "Bars1";
      } else if (index == 2) {
        sectionName = "Bars2";
      } else if (index == 3) {
        sectionName = "Map";
      }
      allocationSection["name"] = `spendAllocation${sectionName}`;
      dashboardOrder.splice(allocationIndex, 0, cloneDeep(allocationMetrics));
      allocationIndex += 1;
    });

    // PDFs can't be processed section by section, we need to get every metric / chart that needs to video and process them sequentially to figure out how much can fit on each page
    let pages = [];
    let currentPage = 0;
    let campaignGroupIndex = dashboardOrder.findIndex((el) => el.name.includes("campaignGroups"));
    for (const [index, section] of dashboardOrder.entries()) {
      if (section.enabled) {
        if (section.metrics_data) {
          let metricNames = section.metrics_data && Object.keys(section.metrics_data);
          let elementsPerRow = 0;
          let elementHeight = 0;
          if (section.name == "goalsAndProjections") {
            elementsPerRow = this.goalsPerRow;
            elementHeight = this.goalRowHeight;
          } else if (section.name == "primaryKpiCharts") {
            elementsPerRow = this.chartsPerRow;
            elementHeight = this.chartRowHeight;
          } else if (section.name == "primaryKpiTables") {
            elementsPerRow = this.metricsPerTable;
            elementHeight = this.tableRowHeight;
          } else if (section.name == "allKpisVsPreviousYear") {
            elementsPerRow = this.kpiBlocksPerRow;
            elementHeight = this.kpiBlockRowHeight;
          } else if (section.name.includes("campaignGroups")) {
            elementsPerRow = this.metricsPerTable;
            if (dashboardOrder[index - 1] && dashboardOrder[index - 1].name.includes("campaignGroups") && !((index - campaignGroupIndex) % 2 == 0) && metricNames.length < 3) {
              elementHeight = 0;
            } else {
              elementHeight = this.groupTableRowHeight;
            }
          } else if (section.name == "spendAllocationPies") {
            elementHeight = this.pieRowHeight;
            elementsPerRow = 3;
          } else if (section.name == "spendAllocationBars1") {
            elementHeight = this.barRowHeight;
            elementsPerRow = 2;
          } else if (section.name == "spendAllocationBars2") {
            elementHeight = this.barRowHeight;
            elementsPerRow = 1;
          } else if (section.name == "spendAllocationMap") {
            elementHeight = this.mapRowHeight;
            elementsPerRow = 1;
          } else {
            return section.name;
          }

          // Create pages array
          if (section.name == "spendAllocationPies") {
            metricNames = ["platform", "device", "gender"];
          }
          if (section.name == "spendAllocationBars1") {
            metricNames = ["age", "day"];
          }
          if (section.name == "spendAllocationBars2") {
            metricNames = ["hour"];
          }
          if (section.name == "spendAllocationMap") {
            metricNames = ["state"];
          }
          metricNames.forEach((metricName, metricIndex) => {
            if (!pages[currentPage]) {
              pages[currentPage] = { metricNames: [], pageHeight: 0 };
            }
            if (metricIndex == 0) {
              console.log("Add 40 pixels for header");
              pages[currentPage]["pageHeight"] += 40;
            }
            if (metricIndex % elementsPerRow == 0 || metricIndex == 0) {
              // 1065px page height - (74px + 10px if header) - 10px bottom padding
              let maxPageHeight = currentPage == 0 ? 971 : 1055;
              if (elementHeight + pages[currentPage]["pageHeight"] > maxPageHeight) {
                console.log(`${elementHeight + pages[currentPage]["pageHeight"]}px Would overflow PDF ${maxPageHeight}px, need to create new page`);
                currentPage += 1;
                if (!pages[currentPage]) {
                  console.log("Initialized new page");
                  pages[currentPage] = { metricNames: [], pageHeight: 40 };
                }
              }
              pages[currentPage]["pageHeight"] += elementHeight;
            }
            pages[currentPage]["metricNames"].push({
              name: metricName,
              section: section.name,
            });

            console.log(
              "section: " +
                section.name +
                " page: " +
                currentPage +
                ", EPR: " +
                elementsPerRow +
                ", name: " +
                metricName +
                ", index: " +
                metricIndex +
                ", page height:" +
                pages[currentPage]["pageHeight"]
            );
          });
        }
      }
    }

    console.log("Pages:");
    console.log(pages);

    if (this.props.enabled) {
      if (jsDig([dashboard, "date"], cc_data)) {
        return (
          <>
            {pages.map((page, index) => {
              return this.generatePdfPage(page, cc_data, dashboard, index);
            })}
          </>
        );
      } else {
        return (
          <>
            <NoData service="video" />;
          </>
        );
      }
    } else {
      return (
        <>
          <ServiceDisabled service="video" userIsEmployee={this.props.user_is_employee} />;
        </>
      );
    }
  }
}

export default PPCPdfVideo;
